// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.step-card {
  display: flex;
  align-items: stretch;
  height: 100%;
  width: 100%;
}
.step-icon {
  font-size: 40px;
  color: #32aa27;
  margin-bottom: 10px;
  line-height: 1;
}
.step-card h3 {
  margin-bottom: 15px;
  font-size: 1.3rem;
}
.centerd-title {
  text-align: center;
  margin-bottom: 30px;
  max-width: 500px;
  margin: 0 auto;
}

/* Why Choose Us Section */
.why-choose-us {
  background-color: #2a5298;
  color: white;
  padding: 80px 0;
  text-align: center;
}

.why-choose-us h2 {
  font-size: 2rem;
  margin-bottom: 50px;
}

.benefits {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
}

.benefit {
  flex-basis: calc(25% - 30px);
  background: rgba(255, 255, 255, 0.1);
  padding: 30px;
  border-radius: 10px;
  min-width: 200px;
}

.benefit h3 {
  margin-bottom: 15px;
}

/* CTA Section */
.cta {
  padding: 80px 0;
  text-align: center;
}

.cta h2 {
  font-size: 2rem;
  margin-bottom: 20px;
  color: #2a5298;
}

.cta p {
  font-size: 1.2rem;
  max-width: 600px;
  margin: 0 auto 30px;
}

/* Responsive Styles */
@media (max-width: 992px) {
  .step {
    flex-basis: calc(50% - 20px);
  }

  .benefit {
    flex-basis: calc(50% - 20px);
  }

  .header-image {
    width: 300px;
    right: 20px;
  }
}

@media (max-width: 768px) {
  .step {
    flex-basis: 100%;
  }

  .benefit {
    flex-basis: 100%;
  }

  .header-image {
    display: none;
  }

  header h1 {
    font-size: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/general/howItWorks/HowItWorks.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".step-card {\n  display: flex;\n  align-items: stretch;\n  height: 100%;\n  width: 100%;\n}\n.step-icon {\n  font-size: 40px;\n  color: #32aa27;\n  margin-bottom: 10px;\n  line-height: 1;\n}\n.step-card h3 {\n  margin-bottom: 15px;\n  font-size: 1.3rem;\n}\n.centerd-title {\n  text-align: center;\n  margin-bottom: 30px;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n/* Why Choose Us Section */\n.why-choose-us {\n  background-color: #2a5298;\n  color: white;\n  padding: 80px 0;\n  text-align: center;\n}\n\n.why-choose-us h2 {\n  font-size: 2rem;\n  margin-bottom: 50px;\n}\n\n.benefits {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 30px;\n}\n\n.benefit {\n  flex-basis: calc(25% - 30px);\n  background: rgba(255, 255, 255, 0.1);\n  padding: 30px;\n  border-radius: 10px;\n  min-width: 200px;\n}\n\n.benefit h3 {\n  margin-bottom: 15px;\n}\n\n/* CTA Section */\n.cta {\n  padding: 80px 0;\n  text-align: center;\n}\n\n.cta h2 {\n  font-size: 2rem;\n  margin-bottom: 20px;\n  color: #2a5298;\n}\n\n.cta p {\n  font-size: 1.2rem;\n  max-width: 600px;\n  margin: 0 auto 30px;\n}\n\n/* Responsive Styles */\n@media (max-width: 992px) {\n  .step {\n    flex-basis: calc(50% - 20px);\n  }\n\n  .benefit {\n    flex-basis: calc(50% - 20px);\n  }\n\n  .header-image {\n    width: 300px;\n    right: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  .step {\n    flex-basis: 100%;\n  }\n\n  .benefit {\n    flex-basis: 100%;\n  }\n\n  .header-image {\n    display: none;\n  }\n\n  header h1 {\n    font-size: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
